import { Button } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useSnackbar } from "src/components/Snackbar";
import { useAppVersionCheck } from "src/hooks/useAppVersionCheck";

const UPDATE_MESSAGE = "A new version is available. Refresh to update.";

export const AppVersionUpdatePrompt = () => {
  const { updateAvailable, refreshNow } = useAppVersionCheck();
  const { showPersistentSnackbar, hidePersistentSnackbar } = useSnackbar();

  const refreshAction = useMemo(
    () => (
      <Button color="inherit" size="small" variant="outlined" onClick={refreshNow}>
        Refresh
      </Button>
    ),
    [refreshNow]
  );

  useEffect(() => {
    if (!updateAvailable) {
      hidePersistentSnackbar();
      return;
    }

    showPersistentSnackbar(UPDATE_MESSAGE, refreshAction);
  }, [
    hidePersistentSnackbar,
    refreshAction,
    showPersistentSnackbar,
    updateAvailable,
  ]);

  useEffect(() => () => hidePersistentSnackbar(), [hidePersistentSnackbar]);

  return null;
};
